/* BDCOM enquiry measurement v2. Uses the Google & YouTube app's tag; no form values or customer details are read. */
(() => {
  'use strict';
  if (window.__bdcomEnquiryTracking) return;
  window.__bdcomEnquiryTracking = true;
  const MEASUREMENT_ID = 'G-JHZSBT4NHL';
  const NATIVE_KEY = 'bdcom_contact_pending_v1';
  const QUEUE_KEY = 'bdcom_event_queue_v2';
  const TTL = 10 * 60 * 1000;
  const MAX_QUEUE = 20;
  const roots = new WeakSet();
  const nativeForms = Object.assign(Object.create(null), {ContactForm:'contact', BrahmaWholesaleContact:'wholesale'});
  let timer = null;

  function permission() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function') return null;
      return privacy.analyticsProcessingAllowed() === true;
    } catch (_) { return null; }
  }
  function read(key, fallback) {
    try {
      const value = window.sessionStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (_) { return fallback; }
  }
  function write(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (_) { return false; }
  }
  function remove(key) {
    try { window.sessionStorage.removeItem(key); return true; }
    catch (_) { return false; }
  }
  function fresh(time) {
    const age = Date.now() - time;
    return Number.isFinite(time) && age >= 0 && age <= TTL;
  }
  function eventId() {
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }
  function queue() {
    const saved = read(QUEUE_KEY, []);
    if (!Array.isArray(saved)) return [];
    return saved.filter(item => item && typeof item.id === 'string' && fresh(item.time) &&
      typeof item.page_location === 'string' &&
      item.page_location.startsWith(window.location.origin + '/') &&
      ((item.name === 'bdcom_enquiry_success' &&
        ((nativeForms[item.details?.form_id] && nativeForms[item.details.form_id] === item.details.lead_type) ||
         (item.details?.form_id === '1151412' && item.details?.lead_type === 'wholesale'))) ||
       (item.name === 'whatsapp_click' && ['footer','page_content'].includes(item.details?.contact_placement))))
      .slice(-MAX_QUEUE);
  }
  function schedule() {
    if (timer === null) timer = window.setTimeout(() => { timer = null; flush(); }, 500);
  }
  function flush() {
    const allowed = permission();
    if (allowed === false) { remove(QUEUE_KEY); remove(NATIVE_KEY); return; }
    let pending = queue();
    if (!pending.length) { remove(QUEUE_KEY); return; }
    if (allowed !== true || typeof window.gtag !== 'function') { schedule(); return; }
    while (pending.length) {
      if (permission() !== true) { remove(QUEUE_KEY); remove(NATIVE_KEY); return; }
      const item = pending.shift();
      // Claim one attempt before dispatch. This is not an Analytics delivery receipt.
      if (!write(QUEUE_KEY, pending)) return;
      try {
        const details = item.name === 'bdcom_enquiry_success'
          ? {lead_type:item.details.lead_type,form_id:item.details.form_id}
          : {contact_placement:item.details.contact_placement};
        window.gtag('event', item.name, {
          send_to:MEASUREMENT_ID,
          page_location:item.page_location,
          ...details
        });
      } catch (_) { /* Do not replay an uncertain dispatch and risk duplicate leads. */ }
    }
    remove(QUEUE_KEY);
  }
  function enqueue(name, details, id = eventId(), time = Date.now(), deferFlush = false) {
    if (permission() !== true || !fresh(time)) return false;
    const pending = queue();
    if (!pending.some(item => item.id === id)) {
      if (pending.length >= MAX_QUEUE) return false;
      pending.push({id,time,name,details,page_location:window.location.origin + window.location.pathname});
    }
    if (!write(QUEUE_KEY, pending)) return false;
    if (!deferFlush) flush();
    return true;
  }
  function nativeSuccess() {
    const marker = document.querySelector('[data-bdcom-contact-success]');
    if (!marker) return;
    const formId = marker.closest('form')?.id;
    if (!nativeForms[formId]) return;
    const pending = read(NATIVE_KEY, null);
    if (!pending) return;
    // Accept an in-flight v1 contact record, but never relabel it as wholesale.
    const savedFormId = pending.form_id || 'ContactForm';
    if (!fresh(pending.time) || pending.path !== window.location.pathname || savedFormId !== formId) {
      remove(NATIVE_KEY); return;
    }
    const allowed = permission();
    if (allowed === false) { remove(NATIVE_KEY); return; }
    if (allowed !== true) return;
    const id = pending.id || 'legacy-' + pending.time + '-' + pending.path;
    if (!enqueue('bdcom_enquiry_success', {lead_type:nativeForms[formId],form_id:formId}, id, pending.time, true)) return;
    // Persist the queue before consuming the success record; dispatch only after both succeed.
    if (!remove(NATIVE_KEY)) { write(QUEUE_KEY, queue().filter(item => item.id !== id)); return; }
    flush();
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!event.isTrusted || !nativeForms[form?.id] || !form.checkValidity()) return;
    if (!remove(NATIVE_KEY) || permission() !== true) return;
    write(NATIVE_KEY, {id:eventId(),time:Date.now(),path:window.location.pathname,form_id:form.id});
  }, true);

  // Retain the existing legacy Shopify Forms detector if that form is ever enabled again.
  function attachWholesale(host) {
    const root = host.shadowRoot;
    if (!root || roots.has(root) || !host.closest('[data-forms-id="forms-root-1151412"]')) return;
    roots.add(root);
    let armedAt = 0;
    let previousStep = root.querySelector('#app-embed')?.getAttribute('data-current-step');
    root.addEventListener('submit', event => {
      if (!event.isTrusted || !event.target?.matches('form[data-testid="form"]')) return;
      armedAt = permission() === true ? Date.now() : 0;
    }, true);
    new MutationObserver(() => {
      const step = root.querySelector('#app-embed')?.getAttribute('data-current-step');
      if (step === 'success' && previousStep !== 'success') {
        const time = armedAt;
        armedAt = 0;
        if (time && fresh(time)) enqueue('bdcom_enquiry_success', {lead_type:'wholesale',form_id:'1151412'}, eventId(), time);
      }
      previousStep = step;
    }).observe(root, {subtree:true,childList:true,attributes:true,attributeFilter:['data-current-step']});
  }
  function findWholesale() {
    if (!window.location.pathname.endsWith('/pages/wholesale-custom-gemstone-sourcing')) return;
    document.querySelectorAll('shopify-forms-embed').forEach(attachWholesale);
  }
  findWholesale();
  if (window.location.pathname.endsWith('/pages/wholesale-custom-gemstone-sourcing')) {
    new MutationObserver(findWholesale).observe(document.documentElement, {childList:true,subtree:true});
    if (window.customElements) window.customElements.whenDefined('shopify-forms-embed').then(findWholesale);
  }
  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const anchor = event.target?.closest?.('a[href]');
    if (!anchor) return;
    let url;
    try { url = new URL(anchor.href); } catch (_) { return; }
    if (url.protocol !== 'https:' || url.hostname !== 'wa.me' || url.pathname !== '/66629567813') return;
    enqueue('whatsapp_click', {contact_placement:anchor.closest('footer') ? 'footer' : 'page_content'});
  }, true);
  function resume() { nativeSuccess(); flush(); }
  document.addEventListener('visitorConsentCollected', resume);
  window.addEventListener('pageshow', resume);
  if (permission() !== null) resume();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) resume(); });
  }
})();
